import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Button,
  useTheme,
  useMediaQuery,
  IconButton,
  RadioGroup,
  FormControl,
  Radio,
  Drawer,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useContext } from "react";
import { QEStrategydataFlowContext } from "../../../main-pages/QEStrategyMainPage";
import LinearProgressBar from "../../../common-components/QMentisLinearProgressBar";
import { uploadCombinedDocumentToTransformer } from "../../../../services/webServices";
import { MessagePopupContext } from "../../../main-pages/ServicePage";
import SessionExpired from "../../../popup-components/SessionExpiredPopup";

const archetypes = [
  "SaaS",
  "Event-Driven",
  "Cloud-Native",
  "Monolithic",
  "Microservices",
  "LLM-Centric",
];

export default function ArchetypeUI() {
  const location = useLocation();
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // const [selected, setSelected] = useState([]);
  // const [useQmentis, setUseQmentis] = useState(false);
  const [loader, setLoader] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);

  const { setMessagePopup, setMessage } = useContext(MessagePopupContext);
  // const [showPreferences, setShowPreferences] = useState(false);

  const heatmap64 = location.state?.heatmap || "";
  const pie_chart64 = location.state?.pie_chart || "";
  const primary_radar_chart64 = location.state?.primary_radar_chart || "";
  const secondary_radar_chart64 = location.state?.secondary_radar_chart || "";
  const tertiary_radar_chart64 = location.state?.tertiary_radar_chart || "";

  const uploadedCSVFromLoactionState = location.state?.uploadedCSV || "";

  const { discoveryLayeroutput, predicted_archetypes, uploadedCSV } =
    location.state || {};

  const twoLayersCsv = uploadedCSVFromLoactionState;

  // Safe fallback
  const predictedArchetypesRaw = location.state?.predicted_archetypes;
  const predictedArchetypes = Array.isArray(predictedArchetypesRaw)
    ? predictedArchetypesRaw
    : predictedArchetypesRaw
    ? JSON.parse(predictedArchetypesRaw)
    : [];
  // Extract classes from backend predictions
  const qmentisValues = predictedArchetypes;

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleSubmit = async () => {
    setLoader(true);

    let chosenArchetypes = [];

    if (selectedOption === "top3") {
      chosenArchetypes = qmentisValues.slice(0, 3);
    } else if (selectedOption === "preferences") {
      // Navigate to preferences page
      setLoader(false);
      navigate(
        "/dashboard/qe-strategyarchetype-predicted/archetype-preferences",
        { state: location.state }
      );
      return;
    } else {
      alert("Please select an option");
      setLoader(false);
      return;
    }

    // Proceed with the 3 chosen archetypes
    const archetypeHeader = chosenArchetypes
      .map((_, i) => `archetype ${i + 1}`)
      .join(",");
    const archetypeRow = chosenArchetypes.join(",");

    const uploadedLines = uploadedCSV.trim().split("\n");
    const headerLine = uploadedLines[0];
    const dataLine = uploadedLines[1];

    const initialCombinedHeader = `${headerLine},${archetypeHeader}`;
    const initialCombinedRow = `${dataLine},${archetypeRow}`;
    const initialCombinedCSV = `${initialCombinedHeader}\n${initialCombinedRow}`;

    const initialBlob = new Blob([initialCombinedCSV], { type: "text/csv" });

    const formData = new FormData();
    formData.append("file", initialBlob, "qe_strategy_report_full.csv");

    // Trigger download of final CSV
    const downloadLink = document.createElement("a");
    const url = URL.createObjectURL(initialBlob);
    downloadLink.href = url;
    downloadLink.download = "qe_strategy_report_full.csv";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);

    try {
      const response = await uploadCombinedDocumentToTransformer(formData);
      setLoader(false);

      const backendData = response.data.pillar_test_suggestions;
      const topQEpillars = response.data.qe_pillars;
      const topQEpillarsChart = response.data.visualizations?.pillars_chart;
      const qePillarConfidences = response.data.all_predictions;
      const pillarsPieChart = response.data.visualizations?.pillars_pie_chart;
      const individualRadarCharts =
        response.data.visualizations?.pillar_radar_base64 || {};

      const updatedConfidences = qePillarConfidences.map((item) => ({
        ...item,
        probability: item.probability * 100,
      }));

      // Add backend results into final CSV
      const backendColumns = [];
      const backendValues = [];

      Object.entries(backendData).forEach(([pillarName, pillarData]) => {
        backendColumns.push(pillarName);
        backendValues.push(pillarData.test_types.join(";"));
      });

      const finalHeader = `${initialCombinedHeader},${backendColumns.join(
        ","
      )}`;
      const finalRow = `${initialCombinedRow},${backendValues.join(",")}`;
      const finalCSV = `${finalHeader}\n${finalRow}`;

      const finalBlob = new Blob([finalCSV], { type: "text/csv" });

      // Navigate forward with full state
      navigate("/dashboard/qe-strategy/advisory-layer", {
        state: {
          topQEpillars: topQEpillars,
          pillarTestSuggestions: backendData,
          backendData: backendData,
          topQEpillarsChart: topQEpillarsChart,
          pillarsPieChart: pillarsPieChart,
          individualRadarCharts: individualRadarCharts,
          finalCSV: finalCSV,
          initialCombinedCSV: initialCombinedCSV,
          updatedConfidences: updatedConfidences,
          heatmap64: heatmap64,
          pie_chart64: pie_chart64,
          primary_radar_chart64: primary_radar_chart64,
          secondary_radar_chart64: secondary_radar_chart64,
          tertiary_radar_chart64: tertiary_radar_chart64,
        },
      });
    } catch (error) {
      console.error("Full error:", error);
      console.error("Error response:", error.response);
      setLoader(false);

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Unknown error occurred";

      setMessage(errorMessage);
      setMessagePopup(true);

      if (errorMessage === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
    }
  };

  return (
    <Box
      sx={{
        // minHeight: "100vh",
        bgcolor: "#f8f6f5",
        p: { xs: 1, sm: 2, md: 3 },
        height: "calc(100vh - 150px)",
        overflowY: "auto",
        maxHeight: "100vh",
      }}
    >
      {/* Main Content Container */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",

          gap: { xs: 2, sm: 2.5, md: 3 },
          maxWidth: 1200,
          mx: "auto",
        }}
      >
        {/* First 2 graphs ( QMentis Indentified Archetypes and Pie chart) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2, sm: 2.5, md: 3 },
            alignItems: "stretch",
          }}
        >
          {/* QMentis Identified ArchetypeHeatmap  */}

          {/* QMentis Identified ArchetypeHeatmap  */}
          <Card
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              boxShadow: { xs: 1, md: 2 },
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Just a title now */}
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{
                  fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.25rem" },
                  mb: 2,
                  textAlign: "center",
                }}
              >
                QMentis Identified Archetypes
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {heatmap64 ? (
                  <Box
                    component="img"
                    src={heatmap64}
                    alt="QMentis Heatmap"
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: { xs: 1, md: 2 },
                      border: "1px solid",
                      borderColor: "grey.200",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      minHeight: 200,
                      border: "2px dashed",
                      borderColor: "grey.300",
                      borderRadius: { xs: 1, md: 2 },
                      bgcolor: "grey.50",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      align="center"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.875rem" },
                      }}
                    >
                      No chart available
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>

          {/* Pie Chart */}
          <Card
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              boxShadow: { xs: 1, md: 2 },
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                fontWeight="bold"
                sx={{
                  fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.25rem" },
                  mb: 2,
                  textAlign: "center",
                }}
              >
                Architecture Distribution
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                {pie_chart64 ? (
                  <Box
                    component="img"
                    src={pie_chart64}
                    alt="Architecture Distribution Pie Chart"
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: { xs: 1, md: 2 },
                      border: "1px solid",
                      borderColor: "grey.200",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      minHeight: 200,
                      border: "2px dashed",
                      borderColor: "grey.300",
                      borderRadius: { xs: 1, md: 2 },
                      bgcolor: "grey.50",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      align="center"
                    >
                      No pie chart available
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Box>

        {/* Radar Graphs Alignments  */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          {/* First 2 Radar Graphs as per the FIGMA */}
          <Card
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              boxShadow: { xs: 1, md: 2 },
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                fontWeight="bold"
                sx={{
                  fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.25rem" },
                  mb: 2,
                  textAlign: "center",
                }}
              >
                Radar-Powered Explainability
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                {primary_radar_chart64 ? (
                  <Box
                    component="img"
                    src={primary_radar_chart64}
                    alt="Architecture Radar Chart"
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: { xs: 1, md: 2 },
                      border: "1px solid",
                      borderColor: "grey.200",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      minHeight: 200,
                      border: "2px dashed",
                      borderColor: "grey.300",
                      borderRadius: { xs: 1, md: 2 },
                      bgcolor: "grey.50",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      align="center"
                    >
                      No radar chart available
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>

          {/* Radar Graphs */}
          <Card
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              boxShadow: { xs: 1, md: 2 },
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                fontWeight="bold"
                sx={{
                  fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.25rem" },
                  mb: 2,
                  textAlign: "center",
                }}
              >
                Radar-Powered Explainability
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                {secondary_radar_chart64 ? (
                  <Box
                    component="img"
                    src={secondary_radar_chart64}
                    alt="Architecture Distribution Pie Chart"
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: { xs: 1, md: 2 },
                      border: "1px solid",
                      borderColor: "grey.200",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      minHeight: 200,
                      border: "2px dashed",
                      borderColor: "grey.300",
                      borderRadius: { xs: 1, md: 2 },
                      bgcolor: "grey.50",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      align="center"
                    >
                      No pie chart available
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Box>

        {/* Final RADAR Graph */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          {/* Final ( 3rd) Radar Chart Card */}
          <Card
            sx={{
              flex: { xs: 1, md: "0 0 calc(50% - 12px)" },
              display: "flex",
              flexDirection: "column",
              boxShadow: { xs: 1, md: 2 },
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                fontWeight="bold"
                sx={{
                  fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.25rem" },
                  mb: 2,
                  textAlign: "center",
                }}
              >
                Radar-Powered Explainability
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                {tertiary_radar_chart64 ? (
                  <Box
                    component="img"
                    src={tertiary_radar_chart64}
                    alt="Architecture Radar Chart"
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: { xs: 1, md: 2 },
                      border: "1px solid",
                      borderColor: "grey.200",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      minHeight: 200,
                      border: "2px dashed",
                      borderColor: "grey.300",
                      borderRadius: { xs: 1, md: 2 },
                      bgcolor: "grey.50",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      align="center"
                    >
                      No radar chart available
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Box>

      {/* Submit Button Container */}
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-end" },
          maxWidth: 1200,
          mx: "auto",
          mt: 2,
          pr: { md: "0.5%" },
        }}
      >
        <Button
          variant="contained"
          // disabled={selected.length === 0}
          sx={{
            borderRadius: 2,
            backgroundColor: "#0094FB",
            textTransform: "none",
            minWidth: { xs: "80%", sm: 120, md: 100 },
            height: { xs: 44, sm: 40, md: 33 },
          }}
          endIcon={<ArrowForwardIcon />}
          onClick={() => setDrawerOpen(true)}
        >
          Next
        </Button>
      </Box>

      {/* Drawer  */}

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        variant="temporary"
        slotProps={{
          paper: {
            sx: {
              width: isMobile ? "100%" : 550,
              maxWidth: "100%",
              p: 3,
              boxSizing: "border-box",
              borderTopLeftRadius: theme.shape.borderRadius,
              borderBottomLeftRadius: theme.shape.borderRadius,
            },
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              onClick={handleDrawerClose}
              edge="start"
              aria-label="back"
              sx={{ color: "black" }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: "bold", ml: 1 }}>
              Choose an option
            </Typography>
          </Box>
          <IconButton onClick={handleDrawerClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Radio Options */}
        <FormControl component="fieldset" sx={{ mb: 4, width: "100%" }}>
          <RadioGroup
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            <Box
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                bgcolor: "#F6FBFF",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                value="top3"
                control={<Radio />}
                label="Proceed with Top 3 Archetypes"
                sx={{ flex: 1, m: 0 }}
              />
            </Box>

            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "#F6FBFF",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                value="preferences"
                control={<Radio />}
                label="Choose your Preferences"
                sx={{ flex: 1, m: 0 }}
              />
            </Box>
          </RadioGroup>
        </FormControl>

        {/* Footer Buttons */}
        <Box
          sx={{
            position: "absolute",
            bottom: 16,
            right: 16,
            left: 16, //  responsive
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // column on small, row on bigger
            gap: 40,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleDrawerClose}
            sx={{
              width: 100, // full width on mobile, 140px on desktop              borderRadius: 2,
              textTransform: "none",
              borderRadius: 2,
              borderColor: "#0094FB",
              fontWeight: 500,
              borderWidth: 2,
            }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!selectedOption}
            sx={{
              width: { xs: "100%", sm: 110 },
              borderRadius: 2,
              backgroundColor: "#0094FB",
              textTransform: "none",
              borderColor: "#0094FB",
              // Custom disabled styles
              "&.Mui-disabled": {
                backgroundColor: "#B3D9FF", // Light blue when disabled
                color: "white", // white text when disabled
              },
            }}
          >
            Proceed
          </Button>
        </Box>
      </Drawer>
      {loader && <LinearProgressBar label={"Analyzing..."} />}
      {sessionExpiredValue && <SessionExpired />}
    </Box>
  );
}
